(() => {
  const ownHosts = new Set([location.hostname.replace(/^www\./, ''), 'storybooksong.com']);
  const original = new WeakMap();
  const update = (anchor) => {
    if (!(anchor instanceof HTMLAnchorElement)) return;
    let url;
    try { url = new URL(anchor.getAttribute('href') || '', location.href); } catch { return; }
    const external = ['http:', 'https:'].includes(url.protocol) && !ownHosts.has(url.hostname.replace(/^www\./, '')) && !anchor.hasAttribute('download');
    if (external) {
      if (!original.has(anchor)) original.set(anchor, { target: anchor.getAttribute('target'), rel: anchor.getAttribute('rel') });
      anchor.target = '_blank';
      anchor.relList.add('noopener', 'noreferrer');
    } else if (original.has(anchor)) {
      const previous = original.get(anchor);
      for (const name of ['target', 'rel']) {
        if (previous[name] === null) anchor.removeAttribute(name);
        else anchor.setAttribute(name, previous[name]);
      }
      original.delete(anchor);
    }
  };
  const scan = (node) => {
    if (node.nodeType !== Node.ELEMENT_NODE && node.nodeType !== Node.DOCUMENT_NODE) return;
    if (node.matches?.('a[href]')) update(node);
    node.querySelectorAll('a[href]').forEach(update);
  };
  scan(document);
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes') update(mutation.target);
      else mutation.addedNodes.forEach(scan);
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  const prepare = (event) => {
    const anchor = event.target.closest?.('a[href]');
    if (anchor) update(anchor);
  };
  for (const name of ['click', 'auxclick', 'pointerdown', 'focusin', 'contextmenu']) document.addEventListener(name, prepare, true);
})();
